import {
  type LoadErpTranslationProps,
  loadErpTranslations,
} from "src/system/loadErpTranslations.ts";

export const erpTranslationsQuery = (props: LoadErpTranslationProps) => {
  return {
    queryKey: ["erp-translations", props],
    queryFn: async () => {
      return await loadErpTranslations(props);
    },
  };
};
